// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field {
  width: 100%;
}
form small.error {
  position: relative;
  top: -20px;
}
a {
  color: #da512d;
  text-decoration: none;
}

.btn {
  color: #ffffff;
  background: linear-gradient(to right, #ee855d, #da512d);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.upload-card {
  border: 2px dashed #e8e0d8;
  border-radius: 14px;
  padding: 24px 28px;
  justify-content: space-between;
  gap: 20px;
  background: #fdfbf9;
  cursor: pointer;
}

.download-btn {
  gap: 6px;
  background: #f5f1ec;
  border: 1.5px solid #e8e0d8;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #4a4a4a;
  cursor: pointer;
}

.download-temp {
  cursor: pointer;
  color: #e8521a;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 8px;
  background: rgba(232, 82, 26, 0.08);
}

.text-sm {
  font-size: 14px;
}

.font-bold {
  font-weight: 600;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/secure/setup/careplus-promo-code-add/careplus-promo-code-add.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uDAAuD;EACvD,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,o7EAAo7E","sourcesContent":[".mat-form-field {\n  width: 100%;\n}\nform small.error {\n  position: relative;\n  top: -20px;\n}\na {\n  color: #da512d;\n  text-decoration: none;\n}\n\n.btn {\n  color: #ffffff;\n  background: linear-gradient(to right, #ee855d, #da512d);\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.upload-card {\n  border: 2px dashed #e8e0d8;\n  border-radius: 14px;\n  padding: 24px 28px;\n  justify-content: space-between;\n  gap: 20px;\n  background: #fdfbf9;\n  cursor: pointer;\n}\n\n.download-btn {\n  gap: 6px;\n  background: #f5f1ec;\n  border: 1.5px solid #e8e0d8;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #4a4a4a;\n  cursor: pointer;\n}\n\n.download-temp {\n  cursor: pointer;\n  color: #e8521a;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 500;\n  gap: 5px;\n  padding: 6px 12px;\n  border-radius: 8px;\n  background: rgba(232, 82, 26, 0.08);\n}\n\n.text-sm {\n  font-size: 14px;\n}\n\n.font-bold {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
